<template>
  <div class="app_navbar">
    <div class="app_navbar_wrapper">
      <div class="brand-label">北京神墨文化传播有限公司</div>
      <div class="navbar_container">
        <div class="navbar_link" @click="todo('/')">首页</div>
        <div class="navbar_link" @click="todo('/news')">付费资讯</div>
        <div class="navbar_link" @click="todo('/about')">关于我们</div>
        <div class="navbar_link" @click="todo('/login')">登陆</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";

const router = useRouter();
const todo = (url: string) => {
  router.push(url);
};

// const link = (url: string) => {
//   location.href = url;
// };
</script>

<style scoped>
.app_navbar {
  position: fixed;
  width: 100%;
  min-width: 1124px;
}

.app_navbar {
  background-color: rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.app_navbar_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.app_navbar_wrapper {
  height: 80px;
  padding: 0 64px;
}

.brand-label {
  font-size: 26px;
  line-height: 1.3;
  color: #fff;
}

.navbar_container {
  display: flex;
  align-items: center;
  gap: 34px;
}

.navbar_link {
  font-size: 18px;
  line-height: 1.3;
  color: #fff;
}

.navbar_link {
  cursor: pointer;
}
</style>
